import { Injectable } from '@angular/core';
import { FactoryBase } from '../../../bases/factory/factory-base';
import { ParserFactory } from '../../../services';

import { SmsLog } from '@osos/shared/api';
import { SMSLogPresenterModel } from '@osos/shared/types';
import { SmsParserV1Service } from '../../../parsers/logs/sms/sms-parser-v1.service';

@Injectable()
export class SmsEntryFactoryService extends FactoryBase<
  SmsLog,
  SMSLogPresenterModel
> {
  constructor(parserFactory: ParserFactory, parser_v1: SmsParserV1Service) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: SMSLogPresenterModel): SmsLog {
    const parser = this.getParser(SmsLog, SMSLogPresenterModel);
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(model: SmsLog): SMSLogPresenterModel {
    const parser = this.getParser(SmsLog, SMSLogPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
